import axios from "axios";
import { API_XANO_BASE_URL } from "../config/api_config";
import { Api_url } from "../common/api_url";
import { axiosAuth } from "../config/axiosInstances";
export const locationCheck = async (id) => {
    //console.log(id);
  try {
    const response = await axiosAuth.get(
      API_XANO_BASE_URL + Api_url.GetLocation,
      { params: { user_id: id } }
      
    );

    //console.log(response);
    if (response.data) {
      //console.log("already present in bakced");
      return true;
    } else {
      //console.log("not present in backend");
      return false;
    }
  } catch (error) {
    console.log(error);
  }
};
